import { FC, ReactNode } from 'react';
import { useSyncHistoryBatch } from 'app/modules/brandHub/hooks/useSyncHistoryBatch';

type Props = {
  children: ReactNode;
};

export const SyncHistoryBatchProvider: FC<Props> = ({ children }) => {
  useSyncHistoryBatch();

  return <>{children}</>;
};
